const BlinkingText = ({ value }) => {
  const style = {
    color: "red",
    fontWeight: "bold",
    fontSize: "24px", // 🔥 Increase the font size here
  };

  return (
    <>
      <style>
        {`
            @keyframes blink {
              0% { opacity: 1; }
              50% { opacity: 0; }
              100% { opacity: 1; }
            }
          `}
      </style>
      <span style={style}>
        <span style={{ animation: "blink 1s infinite" }}>🔥 </span>
        {value}
      </span>
    </>
  );
};

export default BlinkingText;
